import Cookies from "js-cookie";
interface CustomEvent extends Event {
  detail: any;
}

const eventName = "locale:changed";
let func: (e: CustomEvent) => any;
let lang = "en";

const COOKIE_NAME = "SESSvl";

function getCookie(): string {
  return Cookies.get(COOKIE_NAME);
}
function setCookie(language: string): void {
  Cookies.set(COOKIE_NAME, language, {
    expires: 365,
    path: "/",
    secure: false,
    domain: ".matterport.com",
    sameSite: "lax",
  });
}

function broadcast(language: string): void {
  lang = language;
  const event = new CustomEvent("locale:changed", {
    detail: {
      language,
    },
  });
  document.dispatchEvent(event);
}

function listen(callback: (e: CustomEvent) => void) {
  func = callback;
  document.addEventListener(eventName, callback);
}

function remove() {
  document.removeEventListener(eventName, func);
}

export function getLang() {
  return lang;
}

export default {
  broadcast,
  getCookie,
  listen,
  remove,
  setCookie,
};
